// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__-hDbf"};